import {
    Alert,
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControlLabel,
    Grid,
    MenuItem,
    TextField,
    Typography,
} from "@mui/material";
import { useForm } from "../../custom-hooks";
import CloseIcon from "@mui/icons-material/Close";
import { validate } from "../ChatWidget/validate";
import PhoneNumberInput from "../PhoneNumberInput";
import { useState } from "react";
import axios from "axios";
import { Box } from "@mui/system";
import {
    checkConversation,
    newConversation,
    terminateConversation,
} from "../../api/conversation";

export const initialFormValues = {
    // name: "",
    firstName: "",
    lastName: "",
    email: "",
    year: "2022",
    phone: "91",
    // mentorId: "", add it in request
    message_template: "welcome",
    checkBox: false,
    university_mentor: "",
};

export const newMentorQuerySubmit = async (data) => {
    const options = {};
    return await axios.post(
        `https://kw41fi5rla.execute-api.ap-south-1.amazonaws.com/connect/chat`,
        data,
        options
    );
};

const NewApiForm = ({ handleClose, mentor, showSuccessScreen = () => {} }) => {
    const {
        values,
        setValues,
        handleInputChange,
        error,
        setError,
        validateSubmit,
    } = useForm(initialFormValues, validate);

    const [submitClickedOnce, setSubmitClickedOnce] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [alert, setAlert] = useState({ type: "success", show: false });
    const [sameId, setSameId] = useState(false);

    const [showDialog, setShowDialog] = useState(false);
    const [connectedTo, setConnectedTo] = useState(null);

    const openDialog = () => setShowDialog(true);

    const closeDialog = () => setShowDialog(false);

    const newApiInitiate = async () => {
        const requestBody = {
            ...values,
            mentorId: mentor._id,
            mentorPhone: mentor.phone,
            university: mentor.university_mentor,
            name: values.firstName + " " + values.lastName,
        };

        console.log(requestBody);

        const result = await newConversation(requestBody);
        console.log(result);
        showSuccessScreen();
    };

    const handleStartChat = async () => {
        setSubmitClickedOnce(true);
        console.log("clicked");
        if (
            document
                .getElementById(mentor.name.split(" ")[0] + "-form")
                .checkValidity() &&
            validateSubmit()
        ) {
            setSubmitting(true);
            console.log("validated");

            try {
                const result = await checkConversation({
                    phone: values.phone,
                    university: mentor.university_mentor,
                    name: values.firstName + " " + values.lastName,
                    mentorId: mentor._id,
                });

                console.log(result);
                if (result.ok) {
                    // does exist
                    setConnectedTo({
                        ...result.conversation,
                        mentor: result.mentor,
                    });
                    if (result.conversation.mentorId === mentor._id) {
                        // same mentor
                        setSameId(true);
                        setSubmitting(false);
                        setAlert({ type: "success", show: true });
                        setTimeout(() => {
                            setAlert({ type: "success", show: false });
                        }, 3000);
                    } else {
                        // diff mentor
                        openDialog();
                    }
                } else {
                    // does not exist
                    await newApiInitiate();
                }
                setSubmitting(false);
            } catch (e) {
                console.log(e);
            }
        }
    };

    const handleChangeConversation = async () => {
        closeDialog();
        setSubmitting(true);
        console.log("terminating conversation");
        const result = await terminateConversation(connectedTo._id);
        console.log(result);

        console.log("initiating conversation");
        await newApiInitiate();
        setSubmitting(false);
    };

    const handleDontChangeConversation = async () => {
        closeDialog();
        handleClose();
    };

    return (
        <>
            {alert.show && (
                <Alert
                    severity={alert.type}
                    onClose={() =>
                        setAlert((prev) => ({ ...prev, show: false }))
                    }
                >
                    {alert.type === "error"
                        ? "Sorry. There was an error. Please try again"
                        : sameId
                        ? `You are already connected to ${connectedTo.mentor.name}`
                        : "We have sent you a message on whatsapp to connect you with your mentor"}
                </Alert>
            )}
            <form
                id={mentor.name.split(" ")[0] + "-form"}
                onSubmit={(e) => e.preventDefault()}
            >
                <Grid
                    container
                    direction="row"
                    paddingLeft={2}
                    paddingTop={2}
                    paddingRight={2}
                >
                    <Grid item xs={10}>
                        <Typography
                            variant="h5"
                            fontSize="1.2em"
                            fontWeight="bold"
                        >
                            {/* Talk to {mentor.name} */}
                            Talk to {mentor.name}
                        </Typography>
                    </Grid>
                    <Grid item xs={2} align="right">
                        <Button color="inherit" onClick={handleClose}>
                            <CloseIcon sx={{ transform: "scale(1)" }} />
                        </Button>
                    </Grid>
                    <Grid item xs={4.5}>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="firstName"
                            label="First Name"
                            type="field"
                            variant="standard"
                            name="firstName"
                            value={values.firstName}
                            onChange={handleInputChange}
                            required
                            InputLabelProps={{
                                style: { fontFamily: "Outfit" },
                            }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={6.5}>
                        <TextField
                            margin="dense"
                            id="lastName"
                            label="Last Name"
                            type="field"
                            variant="standard"
                            name="lastName"
                            value={values.lastName}
                            onChange={handleInputChange}
                            required
                            InputLabelProps={{
                                style: { fontFamily: "Outfit" },
                            }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            margin="dense"
                            label="Email address"
                            type="email"
                            variant="standard"
                            name="email"
                            value={values.email}
                            onChange={handleInputChange}
                            required
                            InputLabelProps={{
                                style: { fontFamily: "Outfit" },
                            }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} paddingY="8px">
                        <PhoneNumberInput
                            country="in"
                            value={values.phone}
                            onChange={(phone) =>
                                handleInputChange({
                                    target: {
                                        name: "phone",
                                        value: phone,
                                    },
                                })
                            }
                            error={Boolean(error.phone)}
                            errorMsg={error.phone}
                            submitAttempted={submitClickedOnce}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            id="year"
                            select
                            margin="dense"
                            label="When do you wish to apply?"
                            variant="standard"
                            name="year"
                            value={values.year}
                            onChange={handleInputChange}
                            required
                            InputLabelProps={{
                                style: { fontFamily: "DM Sans" },
                            }}
                            fullWidth
                        >
                            {["2022", "2023", "2024", "2025", "2026"].map(
                                (o) => (
                                    <MenuItem key={o} value={o}>
                                        {o}
                                    </MenuItem>
                                )
                            )}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} marginTop={2}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={values.checkBox}
                                    onChange={() => {
                                        setValues((prev) => {
                                            setError((prevError) => ({
                                                ...prevError,
                                                checkBox: validate(
                                                    "checkBox",
                                                    !prev.checkBox
                                                ),
                                            }));
                                            return {
                                                ...prev,
                                                checkBox: !prev.checkBox,
                                            };
                                        });
                                    }}
                                    required
                                />
                            }
                            label={
                                <Typography
                                    variant="h5"
                                    sx={{ fontSize: "1em" }}
                                >
                                    By clicking you agree to our{" "}
                                    <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href={"http://collegeit.org/privacy"}
                                        style={{ textDecoration: "none" }}
                                    >
                                        privacy policy
                                    </a>{" "}
                                    and{" "}
                                    <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href={"http://collegeit.org/tos"}
                                        style={{ textDecoration: "none" }}
                                    >
                                        terms of service
                                    </a>
                                    .
                                </Typography>
                            }
                        />
                    </Grid>
                    <Grid item xs={12} marginTop={2} marginBottom={3}>
                        {!submitting ? (
                            <Button
                                sx={{
                                    textTransform: "none",
                                    fontFamily: "DM Sans",
                                    fontWeight: 500,
                                    backgroundColor: "#2E8EFF",
                                    borderRadius: "7px",
                                    fontSize: "1.05em",
                                    boxShadow:
                                        "0px 0px 0px 0px rgba(0, 0, 0, 0)",
                                    letterSpacing: "0.001em",
                                }}
                                type="submit"
                                variant="contained"
                                onClick={handleStartChat}
                                disabled={submitting}
                            >
                                Start WhatsApp Chat!
                            </Button>
                        ) : (
                            <Box
                                width="100%"
                                display="flex"
                                justifyContent="center"
                            >
                                <CircularProgress />
                            </Box>
                        )}
                    </Grid>
                    {/* parent grid end */}
                </Grid>
            </form>
            <Dialog
                open={showDialog}
                onClose={closeDialog}
                style={{ fontFamily: "Outfit" }}
            >
                <DialogTitle
                    style={{ fontFamily: "Outfit", lineHeight: "1.32" }}
                >
                    You are already connected to {connectedTo?.mentor?.name}
                </DialogTitle>
                <DialogContent style={{ fontFamily: "Outfit" }}>
                    <DialogContentText style={{ fontFamily: "Outfit" }}>
                        Do you wish to terminate the ongoing conversation and
                        start a conversation with {mentor.name} ?
                    </DialogContentText>
                    <DialogActions style={{ fontFamily: "Outfit" }}>
                        <Button
                            onClick={handleDontChangeConversation}
                            variant="outlined"
                        >
                            No
                        </Button>
                        <Button
                            onClick={handleChangeConversation}
                            variant="contained"
                        >
                            Yes
                        </Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default NewApiForm;
